module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-01.a1e42224.svg";